import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import { BobComponent } from "@optee/ui/components/bob/bob.component";
import { IconComponent } from "@optee/ui/components/icon/icon.component";

@Component({
  selector: "swc-icon-card",
  host: { class: "w-64 sm:max-w-xs h-full" },
  template: `
    <oui-bob class="flex h-full w-full flex-1 self-stretch">
      <oui-icon
        class="text-primary-500 mb-4 size-6 lg:size-10"
        [svg]="icon()"
      />

      <h4 class="font-display mb-0.5 font-semibold">
        {{ title() }}
      </h4>

      <ng-content />
    </oui-bob>
  `,
  imports: [IconComponent, BobComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconCardComponent {
  icon = input.required<string>();
  title = input<string>();
}
